<template>
  <div class="emd-interactive-list eu-mb_3">
    <div class="emd-interactive-list__main">
      <p class="emd-text eu-pa_1" v-if="!loadingList && !testAccounts.items.length">{{$t('no-results')}}</p>
      <div class="emd-loader _invert eu-align_center eu-pa_3" v-if="loadingList">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div v-if="!loadingList && testAccounts.items.length" class="emd-select-list">
        <ul>
          <li class="emd-select-list__item" v-for="(acc, index) in testAccounts.items" :key="index" v-bind:class="{'_active': acc.id === account.id}" v-on:click="goToAccount(acc.id)">
            <span class="emd-select-list__label">
              <span class="emd-status-tag" :class="acc.status == 'inactive' ? '_color_danger' : '_color_warning'" v-bind:title="$t(`account.test.${acc.status}`)">
                <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                  <path fill="currentColor" d="M8,0 C3.58064516,0 0,3.58064516 0,8 C0,12.4193548 3.58064516,16 8,16 C12.4193548,16 16,12.4193548 16,8 C16,3.58064516 12.4193548,0 8,0 Z"></path>
                </svg>
              </span>
              {{acc.name}}
            </span>
            <span class="emd-select-list__select-icon" v-if="acc.id === account.id">
              <span class="emd-status-tag">
                <i class="uil uil-check-circle"></i>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="emd-interactive-list__pagination" v-if="!loadingList && testAccounts.pagination.total_page > 1">
      <button class="emd-btn _type_text _size_small" v-bind:class="{'_disabled': testAccounts.pagination.current_page === 1}" v-on:click.stop="goToPage(page-1)" :disabled="testAccounts.pagination.current_page === 1">
        {{$t('pagination.previous')}}
      </button>
      <span class="emd-text _size_tiny _align_center">
        {{testAccounts.pagination.current_page}} {{$t('pagination.of')}} {{testAccounts.pagination.total_page}}
      </span>
      <button class="emd-btn _type_text _size_small" v-bind:class="{'_disabled': testAccounts.pagination.current_page === testAccounts.pagination.total_page}" v-on:click.stop="goToPage(page+1)" :disabled="testAccounts.pagination.current_page === testAccounts.pagination.total_page">
        {{$t('pagination.next')}}
      </button>
    </div>
  </div>
</template>

<i18n>
{
  "pt-BR": {
    "search": "Buscar...",
    "no-results": "Não foram encontrados resultados.",
    "pagination": {
      "previous": "Anterior",
      "of": "de",
      "next": "Próximo"
    }
  },
  "en-US": {
    "search": "Search...",
    "no-results": "No results found.",
    "pagination": {
      "previous": "Previous",
      "of": "of",
      "next": "Next"
    }
  }
}
</i18n>

<script>
export default {
  name: 'InteractiveListProduction',
  props: {
    merchant: {
      type: Object
    },
    account: {
      type: Object
    }
  },
  data () {
    return {
      loadingList: true,
      prodAccounts: [],
      identifier: '',
      page: 1,
      debounceTimer: undefined
    }
  },
  computed: {
    isTestAccount () {
      return this.account.account_type.key === 'test'
    },
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    },
    initialRoute () {
      return this.hasSubscriptionEnabled ? 'OrderType' : 'Items'
    }
  },
  methods: {
    getTestAccounts (merchantId, accountId, query = {}) {
      this.loadingList = true
      this.$store.dispatch('GET_TEST_ACCOUNTS', { merchantId, accountId, query }).then((res) => {
        this.testAccounts = this.$store.getters.testAccounts
        this.loadingList = false
      })
    },
    toggleTestAccounts () {
      const accountId = this.isTestAccount ? this.account.master_account_id : this.account.id
      this.isOpenned = !this.isOpenned
      this.getTestAccounts(this.merchant.id, accountId)
    },
    goToPage (page) {
      this.page = page
      const accountId = this.isTestAccount ? this.account.master_account_id : this.account.id
      const query = { page: this.page }
      if (this.identifier) { query.identifier = this.identifier }
      this.getTestAccounts(this.merchant.id, accountId, query)
    },
    goToAccount (accountId) {
      this.$store.dispatch('toggleGlobalLoading', true)
      this.$store.dispatch('SET_ACCOUNT_ENABLED', null)
      this.$store.dispatch('RESET_PAYMENTS_ENABLED')
      this.$store.dispatch('RESET_PAYMENT_STATE')
      this.$store.dispatch('RESET_ORDER_STATE')
      this.$store.dispatch('RESET_PERMISSION', this.initialRoute)
      this.$router.push({ path: `/${this.merchant.id}/${accountId}/` }).catch(err => err)
      this.$store.dispatch('GET_AUTHORIZATION', { merchant_id: this.merchant.id, account_id: accountId })
    }
  },
  activated () {
    if (!Object.entries(this.prodAccounts).length) {
      const accountId = this.isTestAccount ? this.account.master_account_id : this.account.id
      this.getTestAccounts(this.merchant.id, accountId)
    }
  }
}
</script>
